<template>
  <div class="brand-evaluation-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>品牌评价管理</span>
      </div>
      <div v-if="!hasPermission" class="no-permission">
        <el-alert
          title="没有权限查看品牌评价"
          type="warning"
          :closable="false"
          show-icon
        >
          <div slot="description">
            请联系管理员为当前应用配置访问品牌评价的权限。
          </div>
        </el-alert>
      </div>
      <el-table v-else :data="evaluations" border style="width: 100%">
        <el-table-column type="index" label="序号" width="80" />
        <el-table-column prop="brandName" label="品牌名称" />
        <el-table-column prop="userName" label="用户名称" />
        <el-table-column prop="score" label="评分">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.score" disabled :max="5" />
          </template>
        </el-table-column>
        <el-table-column prop="content" label="评价内容" />
        <el-table-column prop="createTime" label="评价时间" />
        <el-table-column prop="reply" label="回复">
          <template slot-scope="scope">
            <el-input v-model="scope.row.reply" type="textarea" :rows="2" placeholder="请输入回复" />
            <div class="reply-actions">
              <el-button type="primary" size="small" @click="handleReply(scope.row)">{{ scope.row.reply ? '更新回复' : '回复' }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="handleRemoveEvaluation(scope.row)">删除评价</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="hasPermission"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      />
    </el-card>
  </div>
</template>

<script>
import { listBrandEvaluations, replyBrandEvaluation, removeBrandEvaluation } from '@/api/shop/brandApi'

export default {
  name: 'BrandEvaluation',
  data() {
    return {
      evaluations: [],
      page: 1,
      row: 10,
      total: 0,
      hasPermission: true
    }
  },
  created() {
    this.loadEvaluations()
  },
  methods: {
    async loadEvaluations() {
      try {
        console.log('Loading evaluations with params:', { page: this.page, row: this.row })
        const response = await listBrandEvaluations({
          page: this.page,
          row: this.row
        })
        console.log('Evaluation response:', response)
        // axios 响应的 data 字段才是 API 返回的实际数据
        const apiResponse = response.data
        console.log('API response data:', apiResponse)
        if (apiResponse.code === 0) {
          this.evaluations = apiResponse.data
          this.total = apiResponse.total
          this.hasPermission = true
          console.log('Evaluations loaded successfully:', this.evaluations)
        } else if (apiResponse.msg && apiResponse.msg.includes('鉴权失败')) {
          // 处理鉴权失败的情况
          this.hasPermission = false
          console.warn('没有权限查看品牌评价')
        } else {
          console.error('API returned error:', apiResponse)
          this.$message.error(apiResponse.msg || '加载评价失败')
        }
      } catch (error) {
        console.error('Failed to load evaluations:', error)
        console.error('Error message:', error.message)
        console.error('Error stack:', error.stack)
        this.$message.error('加载评价失败')
      }
    },
    handleSizeChange(size) {
      this.row = size
      this.loadEvaluations()
    },
    handleCurrentChange(current) {
      this.page = current
      this.loadEvaluations()
    },
    async handleReply(row) {
      try {
        const response = await replyBrandEvaluation({
          evaluationId: row.evaluationId,
          reply: row.reply
        })
        console.log('Reply response:', response)
        if (response.data && response.data.code === 0) {
          this.$message.success(row.reply ? '更新回复成功' : '回复成功')
        } else {
          this.$message.error('操作失败')
        }
      } catch (error) {
        console.error('Failed to reply:', error)
        this.$message.error('操作失败')
      }
    },
    async handleRemoveEvaluation(row) {
      try {
        // 显示确认对话框
        await this.$confirm('确定要删除这条评价吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await removeBrandEvaluation(row.evaluationId)
        console.log('Remove evaluation response:', response)
        if (response.data && response.data.code === 0) {
          this.$message.success('删除评价成功')
          // 重新加载评价列表
          this.loadEvaluations()
        } else {
          this.$message.error('删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Failed to remove evaluation:', error)
          this.$message.error('删除失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-evaluation-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }

  .no-permission {
    margin-bottom: 20px;
  }

  .reply-actions {
    margin-top: 8px;
    display: flex;
    gap: 8px;
  }
}
</style>